import { LinearProgress } from "@mui/material";

const Loading = ({ loading }) => {
  if (!loading) return null;
  return (
    <LinearProgress
      color="primary"
      sx={{ borderRadius: 1, mb: 1 }}
      aria-label="Cargando datos"
    />
  );
};

export default Loading;
